import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { IConsultationRequestInboxModel } from "@/Portfolio/Models/UI/IConsultationRequestsInboxModel";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";

class MyConsultationRequestsSettingsContainerHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Portfolio.MyConsultationRequests_SearchSettings_ShowOptionsButtonClick, this.DisplayMyConsultationRequestsSettings);
        this.RegisterOperation(LocalOperations.Portfolio.MyConsultationRequests_SearchSettings_CancelClick, this.OnCancelClick);
        this.RegisterOperation(LocalOperations.Portfolio.MyConsultationRequests_SearchSettings_OkClick, this.OnOkClick);
        this.RegisterOperation(LocalOperations.Portfolio.MyConsultationRequests_SearchSettings_ColumnOrderingPopup_Open, this.ShowColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Portfolio.MyConsultationRequests_SearchSettings_ColumnOrderingPopup_Close, this.CloseColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.CloseSearchFilterPopup, false);
    }

    private ShowColumnOrderingPopup(request: LocalEvent, store: PortfolioStore): void {
        store.ConsultationRequestsInboxModel = store.ConsultationRequestsInboxModel
            .set("ColumnOrderingPopupOpen", true)
            .set("ShowMyConsultationRequestsDisplaySettings", false);
    }

    private CloseColumnOrderingPopup(request: LocalEvent, store: PortfolioStore): void {
        store.ConsultationRequestsInboxModel = store.ConsultationRequestsInboxModel
            .set("ColumnOrderingPopupOpen", false)
            .set("ShowMyConsultationRequestsDisplaySettings", false);
    }

    private OnOkClick(request: LocalEvent, store: PortfolioStore): void {
        store.ConsultationRequestsInboxModel = (request.Get<IConsultationRequestInboxModel>("updatedModel") ?? store.ConsultationRequestsInboxModel)
            .set("ShowMyConsultationRequestsDisplaySettings", false);
        store.PortfolioActions.LoadMyConsultationRequests(store.ConsultationRequestsInboxModel);
    }

    private OnCancelClick(request: LocalEvent, store: PortfolioStore): void {
        store.ConsultationRequestsInboxModel = store.ConsultationRequestsInboxModel.set("ShowMyConsultationRequestsDisplaySettings", false);
    }

    private DisplayMyConsultationRequestsSettings(request: LocalEvent, store: PortfolioStore): void {
        const isOpen = store.ConsultationRequestsInboxModel.get("ShowMyConsultationRequestsDisplaySettings");
        store.ConsultationRequestsInboxModel = store.ConsultationRequestsInboxModel.set("ShowMyConsultationRequestsDisplaySettings", !isOpen);
    }

    private CloseSearchFilterPopup(request: LocalEvent, store: PortfolioStore): void {
        if (store.ConsultationRequestsInboxModel.get("ShowMyConsultationRequestsDisplaySettings") === true) {
            this.OnOkClick(request, store);
            store.EmitChangeToListeners();
        }
    }
}

export { MyConsultationRequestsSettingsContainerHandler };
